import { render, staticRenderFns } from "./DialogPlug4Market.vue?vue&type=template&id=2635618b"
import script from "./DialogPlug4Market.vue?vue&type=script&lang=js"
export * from "./DialogPlug4Market.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports